import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
import { observer } from "mobx-react";
import { Dropdown } from "antd";
import { EmailReceiversModal } from "../EmailReceiversModal";
import { contactsStore } from "Stores/ContactsStore";
import { groupListStore } from "Pages/Project/Groups/Stores/GroupsStore";
import { GroupsModalItem } from "./GroupsModalItem";
import { stringSort } from "utils/defaultSort";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ContactsModalItem } from "./ContactsModalItem";
import { emailSubmitStore } from "../../Stores/EmailSubmitStore";
import { FormInstance } from "antd/lib/form";

interface GhostButtonProps {
  icon: IconProp;
  name: string | React.ReactNode;
  style?: React.CSSProperties;
  onClick?: () => void;
}

const GhostButton = ({ icon, name, style, onClick }: GhostButtonProps) => {
  return (
    <div className="ghost-button" style={style} onClick={onClick}>
      <FontAwesomeIcon style={{ marginRight: 5 }} icon={icon} fixedWidth={true} className="icon" />
      {name}
    </div>
  );
};

interface TopBarProps {
  toggleFilesModal: () => void;
  form: FormInstance;
}

interface TopBarState {
  isContactsVisible: boolean;
  isGroupsVisible: boolean;
}

// tslint:disable-next-line: max-line-length
export const TopBar = withTranslation(I18N_NS.PROJECT)(
  observer(
    class extends React.Component<TopBarProps & WithTranslation, TopBarState> {
      constructor(props: TopBarProps & WithTranslation) {
        super(props);
        this.state = {
          isContactsVisible: false,
          isGroupsVisible: false,
        };
      }

      handleSaveReceivers = (formData: API_MailRequest) => {
        this.props.form.setFieldsValue(formData);
        this.setState({ isContactsVisible: false, isGroupsVisible: false });
      };

      handleChangePriority = ({ key }) => {
        this.props.form.setFieldsValue({ importance: key });
        emailSubmitStore.update({ importance: key });
      };

      toggleModal = (key: keyof TopBarState) => {
        this.setState({ [key]: !this.state[key] } as any); // eslint-disable-line @typescript-eslint/no-explicit-any
      };

      render() {
        const { t } = this.props;

        return (
          <>
            <div style={{ position: "relative", fontSize: 0, top: -10 }}>
              <GhostButton
                icon={["fas", "user-alt"]}
                onClick={() => this.toggleModal("isContactsVisible")}
                name={t("Contacts")}
              />
              <GhostButton
                icon={["fas", "users"]}
                onClick={() => this.toggleModal("isGroupsVisible")}
                name={t("Groups")}
              />
              <Dropdown
                menu={{
                  items: [
                    { key: "NORMAL", label: t("Normal") },
                    { key: "HIGH", label: t("High") },
                  ],
                  onClick: this.handleChangePriority,
                  selectedKeys: [emailSubmitStore.data.importance || "NORMAL"],
                }}
                trigger={["click"]}
              >
                <span style={{ display: "inline-block" }}>
                  <GhostButton icon={["fas", "exclamation"]} name={t("Priority")} />
                </span>
              </Dropdown>
            </div>
            <EmailReceiversModal
              onCancel={() => this.toggleModal("isContactsVisible")}
              data={contactsStore.allData}
              isVisible={this.state.isContactsVisible}
              modalTitle={t("Contacts")}
              onSave={this.handleSaveReceivers}
              getFormFieldValues={this.props.form?.getFieldsValue}
              render={(state, data, onChange) => {
                return data
                  .sort((a, b) => stringSort(a, b, "name"))
                  .map((item, index) => {
                    return <ContactsModalItem key={index} state={state} data={item} onCheckboxChange={onChange} />;
                  });
              }}
            />
            <EmailReceiversModal
              onCancel={() => this.toggleModal("isGroupsVisible")}
              data={groupListStore.forMailAndPlot}
              isVisible={this.state.isGroupsVisible}
              modalTitle={t("Groups")}
              onSave={this.handleSaveReceivers}
              getFormFieldValues={this.props.form?.getFieldsValue}
              render={(state, data, onChange) => {
                return data
                  .sort((a, b) => stringSort(a, b, "name"))
                  .map((item, index) => {
                    return <GroupsModalItem key={index} state={state} data={item} onCheckboxChange={onChange} />;
                  });
              }}
            />
          </>
        );
      }
    }
  )
);
